import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { EDUCATION_DATA } from '../../constants';
import TimelineItem from '../TimelineItem/TimelineItem';
import content from '../../i18n/content';
import './Education.css';

export default function Education() {
  const { lang } = useLanguage();
  const t = content[lang].education;

  return (
    <section id="education" className="education-section">
      <h2>{t.sectionTitle}</h2>
      {EDUCATION_DATA.map((entry) => {
        const copy = t.items[entry.id];
        return (
          <TimelineItem
            key={entry.id}
            title={copy.title}
            subtitle={copy.academy}
            period={entry.years}
          />
        );
      })}
    </section>
  );
}
